import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormControl, Validators } from '@angular/forms';
import { SelectStepComponent } from '../../step/select-step/select-step.component';

@Component({
  selector: 'app-loan-purpose',
  templateUrl: './loan-purpose.component.html',
  styleUrls: ['./loan-purpose.component.scss', '../../step/step.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})

export class LoanPurposeComponent extends SelectStepComponent implements OnInit {

  @ViewChild('cashOutReason') cashOutReasonField: ElementRef;
  public debtSettlement: boolean;
  public title: string;

  ngOnInit(): void {
    this.debtSettlement = this.form.controls.formType.value == 'debtsettlement' || this.form.controls.formType.value == 'debtrelief';
    this.title = this.form.controls.formType.value == 'debtsettlement' || this.form.controls.formType.value == 'debtrelief' ? 'Reason For Debt Relief' : 'Select a loan purpose'

    this.control = new UntypedFormControl('', Validators.required);
    this.form.addControl('cashOutReason', this.control);
  }

  submit () : void {
    if (this.cashOutReasonField.nativeElement.value.trim() == '') {
      this.form.get('cashOutReason').setValue('debt-consolidation');
      super.submit();
    } else {
      this.cashOutReasonField.nativeElement.value = this.cashOutReasonField.nativeElement.value.trim();
      super.submit();
    }
    
  }
}